// extracted by mini-css-extract-plugin
export default {"error":"error__NmY4N"};